/**
 * The single focus treatment for the whole design system. Every interactive
 * element restates it so that class merging can never silently drop it.
 *
 * `theme.css` also sets a `:focus-visible` outline on `:root` as a safety net
 * for markup the apps write themselves; the two produce the same ring.
 */
export const focusRing =
  'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-b';
